import React from 'react';
import Checkbox from '../Checkbox';
import Input from '../Input';
import styles from './RequiredField.scss';

function RequiredField(props) {
  const {
    label,
    type,
    meta: { touched, error },
  } = props;

  const newProps = {
    ...props,
    label: (
      <span>
        {label}
        <span className={`${(touched && error) && 'mc-form--invalid'} ${styles.asterisk}`}>*</span>
      </span>
    ),
  };

  if (type === 'checkbox') {
    return <Checkbox {...newProps} />;
  }

  return <Input {...newProps} />;
}

export default RequiredField;
